'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _topNav = require('./topNav');

var _topNav2 = _interopRequireDefault(_topNav);

var _desktopSecNav = require('./desktopSecNav');

var _desktopSecNav2 = _interopRequireDefault(_desktopSecNav);

var _mobileSecNav = require('./mobileSecNav');

var _mobileSecNav2 = _interopRequireDefault(_mobileSecNav);

var _i18n = require('../utils/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _converter = require('../utils/converter');

var _converter2 = _interopRequireDefault(_converter);

var _reactI18next = require('react-i18next');

require('./styles.css');

require('../icon.css');

require('../fa.css');

require('bootstrap/dist/css/bootstrap.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NavIndexContainer(props) {
    var isLogin = props.isLogin,
        handleChangeLang = props.handleChangeLang,
        handleLoginPress = props.handleLoginPress,
        darkMode = props.darkMode,
        disableLogin = props.disableLogin,
        children = props.children,
        hoverSectionAndPath = props.hoverSectionAndPath,
        handleSearch = props.handleSearch,
        onURLClick = props.onURLClick,
        currentLang = props.currentLang,
        loadingComplete = props.loadingComplete,
        isHeaderFixedTop = props.isHeaderFixedTop;
    // const [businessType, setBusinessType] = useLocalStorage("businessType", null);

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        showMobileMenu = _useState2[0],
        setShowMobileMenu = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        showLV1 = _useState4[0],
        setShowLV1 = _useState4[1];

    var _useState5 = (0, _react.useState)(''),
        _useState6 = _slicedToArray(_useState5, 2),
        lv1Selection = _useState6[0],
        setLv1Selection = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        _useState8 = _slicedToArray(_useState7, 2),
        lv2Selection = _useState8[0],
        setLv2Selection = _useState8[1];

    var _useState9 = (0, _react.useState)(null),
        _useState10 = _slicedToArray(_useState9, 2),
        subNavLV2Index = _useState10[0],
        setSubNavLV2Index = _useState10[1];

    var _useState11 = (0, _react.useState)(null),
        _useState12 = _slicedToArray(_useState11, 2),
        subNavLV3Index = _useState12[0],
        setSubNavLV3Index = _useState12[1];

    var _useState13 = (0, _react.useState)(""),
        _useState14 = _slicedToArray(_useState13, 2),
        marginLeft = _useState14[0],
        setMarginLeft = _useState14[1];

    var _useState15 = (0, _react.useState)(!(0, _lodash.isEmpty)(props.aioURL) ? props.aioURL : 'http://www.hkbn.net/personal/'),
        _useState16 = _slicedToArray(_useState15, 2),
        aioURL = _useState16[0],
        setAIOURL = _useState16[1];

    var _useState17 = (0, _react.useState)(!(0, _lodash.isEmpty)(props.myAccountURL) ? props.myAccountURL : 'http://www.hkbn.net/'),
        _useState18 = _slicedToArray(_useState17, 2),
        myAccountURL = _useState18[0],
        setMyAccountURL = _useState18[1];

    var topNavRef = (0, _react.useRef)();
    // let mainTopNavRef = useRef();

    var _useState19 = (0, _react.useState)(90),
        _useState20 = _slicedToArray(_useState19, 2),
        mainTopNavHeight = _useState20[0],
        setMainTopNavHeight = _useState20[1];

    var _useState21 = (0, _react.useState)(null),
        _useState22 = _slicedToArray(_useState21, 2),
        node = _useState22[0],
        setNode = _useState22[1];

    var mainTopNavRef = (0, _react.useCallback)(function (node) {
        if (node !== null) {
            setNode(node);
        }
    }, []);
    (0, _react.useLayoutEffect)(function () {
        if (node) {
            var measure = function measure() {
                setMainTopNavHeight(node.getBoundingClientRect().height);
            };

            measure();
            window.addEventListener("resize", measure);

            return function () {
                window.removeEventListener("resize", measure);
            };
        }
    }, [node]);

    (0, _react.useEffect)(function () {}, [showMobileMenu]);

    (0, _react.useEffect)(function () {
        _i18n2.default.changeLanguage(currentLang === 'eng' ? 'en-US' : 'zh-HK');
    }, [currentLang]);

    var handleMenuMouseEnter = function handleMenuMouseEnter(item, itemIndex) {
        setShowLV1(true);
        setSubNavLV2Index(itemIndex);
        returnSectionAndPath(item ? item.url : "");
        if (topNavRef.current) {
            setMarginLeft("calc(" + (0, _lodash.get)(mainTopNavRef, 'current.offsetLeft', 0) + "px + " + (0, _lodash.get)(topNavRef, 'current.children[' + itemIndex + '].offsetLeft', 0) + "px - 2rem");
        }
    };
    var handleItemClick = function handleItemClick(fullURL, caller) {
        var hasReplaceableSiteOrigin = fullURL.match(/\[\[.*?\]\]/);
        var url = void 0;
        var path = void 0;
        var urlOrigin = void 0;

        if (!(0, _lodash.isEmpty)(hasReplaceableSiteOrigin)) {
            urlOrigin = hasReplaceableSiteOrigin[0].slice(0, -2).substring(2); // aio
            switch (urlOrigin) {
                case 'aio':
                    url = fullURL.replace('[[aio]]', aioURL); //'[[aio]]home/en/landing' => 'http://www.hkbn.net/personal/home/en/landing'
                    path = fullURL.replace('[[aio]]', ''); //'[[aio]]home/en/landing' => 'home/en/landing'
                    break;
                case 'myaccount':
                    url = fullURL.replace('[[myaccount]]', myAccountURL);
                    path = fullURL.replace('[[myaccount]]', '');
                    break;
                default:
                    url = fullURL;
                    break;
            }
        } else {
            urlOrigin = 'default';
            url = fullURL;
        }
        setShowMobileMenu(false);
        onURLClick(url, path, caller, urlOrigin);
    };
    var handleLV1ItemClick = function handleLV1ItemClick(item) {
        setLv1Selection(item);
        setBusinessType(item);
    };
    var handleLV2MouseOver = function handleLV2MouseOver(item, itemIndex) {
        setLv2Selection(item.section);
        setSubNavLV3Index(itemIndex);
    };
    var returnSectionAndPath = function returnSectionAndPath(fullURL) {
        var hasReplaceableSiteOrigin = fullURL.match(/\[\[.*?\]\]/);
        var url = void 0;
        var urlOrigin = void 0;
        var section = null;
        var path = null;

        if (!(0, _lodash.isEmpty)(hasReplaceableSiteOrigin)) {
            urlOrigin = hasReplaceableSiteOrigin[0].slice(0, -2).substring(2);
            switch (urlOrigin) {
                case 'aio':
                    url = fullURL.replace('[[aio]]', '');
                    break;
                default:
                    url = fullURL;
                    break;
            }
            var tempArray = url.split('/');
            section = tempArray[0];
            path = !(0, _lodash.isEmpty)(tempArray[2]) ? tempArray[2] : null;
        }
        if ((0, _lodash.isFunction)(hoverSectionAndPath)) {
            hoverSectionAndPath(section, path);
        }
    };

    var returnFullURL = function returnFullURL(fullURL) {
        if ((0, _lodash.isEmpty)(fullURL)) {
            return;
        }
        var hasReplaceableSiteOrigin = fullURL.match(/\[\[.*?\]\]/);
        var urlOrigin = void 0;
        var url = fullURL;
        if (!(0, _lodash.isEmpty)(hasReplaceableSiteOrigin)) {
            urlOrigin = hasReplaceableSiteOrigin[0].slice(0, -2).substring(2);
            switch (urlOrigin) {
                case 'aio':
                    url = fullURL.replace('[[aio]]', aioURL);
                    break;
                default:
                    url = fullURL;
                    break;
            }
        }
        return url;
    };

    var navBarStyles = (0, _react.useMemo)(function () {
        if (showMobileMenu) {
            return {};
        }
        return {
            height: isHeaderFixedTop ? (mainTopNavHeight || 90) + 'px' : 'auto'
        };
    }, [showMobileMenu, isHeaderFixedTop, mainTopNavHeight]);

    if (!loadingComplete) {
        return false;
    }
    return _react2.default.createElement(
        'div',
        {
            style: navBarStyles,
            className: 'CommonLibraryNavBar ' + (showMobileMenu ? "fixedTop" : ""),
            onMouseLeave: function onMouseLeave() {
                setSubNavLV2Index(null);setLv2Selection(null);
            }
        },
        _react2.default.createElement(
            _reactI18next.I18nextProvider,
            { i18n: props.i18n },
            _react2.default.createElement(_topNav2.default, {
                isLogin: isLogin,
                handleChangeLang: handleChangeLang,
                handleLoginPress: handleLoginPress,
                darkMode: darkMode,
                disableLogin: disableLogin,
                showMobileMenu: showMobileMenu,
                setShowMobileMenu: setShowMobileMenu,
                handleMenuMouseEnter: handleMenuMouseEnter,
                children: children,
                handleSearch: handleSearch,
                onURLClick: handleItemClick,
                ref: { mainTopNavRef: mainTopNavRef, topNavRef: topNavRef },
                lang: currentLang === 'eng' ? 'en' : 'tc',
                returnFullURL: returnFullURL,
                headerChild: props.headerChild,
                isHeaderFixedTop: isHeaderFixedTop
            }),
            _react2.default.createElement(_desktopSecNav2.default, {
                darkMode: darkMode,
                subNavLV2Index: subNavLV2Index // subNavLV2Index HeaderContentCn.pages[1].subNav
                , subNavLV3Index: subNavLV3Index // subNavLV3Index HeaderContentCn.pages[1].subNav.content[0]
                , setSubNavLV2Index: setSubNavLV2Index,
                showLV1: showLV1,
                lv1Selection: lv1Selection,
                lv2Selection: lv2Selection,
                setShowLV1: setShowLV1,
                returnSectionAndPath: returnSectionAndPath,
                handleLV2MouseOver: handleLV2MouseOver,
                onURLClick: function onURLClick(url, pageName) {
                    handleItemClick(url, pageName);
                    setSubNavLV2Index(null);
                    setLv2Selection(null);
                },
                marginLeft: marginLeft,
                returnFullURL: returnFullURL
            }),
            _react2.default.createElement(_mobileSecNav2.default, {
                handleChangeLang: handleChangeLang,
                showMobileMenu: showMobileMenu,
                handleMenuMouseEnter: handleMenuMouseEnter,
                subNavLV2Index: subNavLV2Index,
                onURLClick: handleItemClick,
                setShowMobileMenu: setShowMobileMenu,
                setSubNavLV2Index: setSubNavLV2Index
            })
        )
    );
}

exports.default = NavIndexContainer;